const commonGeometryTypes = {
    "Point": "Point",
    "MultiPoint": "MultiPoint",
    "LineString": "LineString",
    "MultiLineString": "MultiLineString",
    "Polygon": "Polygon",
    "MultiPolygon": "MultiPolygon",
    "Circle": "Circle",
    "anyGeometryType": "anyGeometryType"
};


module.exports = commonGeometryTypes;